import React from 'react';
import useVersionCheck from 'hooks/useVersionCheck';
import VersionNoticeBar from 'components/VersionNoticeBar';

const VersionChecker = () => {
  const { hasNewVersion, isDismissed, isReloading, onReload, onDismiss } = useVersionCheck();

  if (hasNewVersion && !isDismissed) {
    return (
      <VersionNoticeBar
        isReloading={isReloading}
        onReload={onReload}
        onDismiss={onDismiss}
      />
    );
  }

  return null;
};

export default VersionChecker;
